window.primaryMenu = () => {

	/**
	 * Mega menu hover first child menu if not hover on any menu item.
	 *
	 * @return {void}
	 */
	const megaMenuInitHover = () => {
		const primaryMenuWrap = document.getElementById( 'primary-nav' );

		if ( null !== primaryMenuWrap ) {
			const allMegaMenus = primaryMenuWrap.querySelectorAll( '.has-mega-menu' );

			if ( null !== allMegaMenus ) {

				allMegaMenus.forEach( ( megaMenu ) => {
					const firstMenuItem = megaMenu.querySelector( '.sub-menu > li:first-child' );
					firstMenuItem.classList.add( 'is-hover' );

					const siblingMenuItems = Array.from( firstMenuItem.parentNode.children ).filter( ( item ) => item !== firstMenuItem );

					siblingMenuItems.forEach( ( item ) => {
						item.addEventListener( 'mouseenter', () => {
							firstMenuItem.classList.remove( 'is-hover' );
						} );

						item.addEventListener( 'mouseleave', () => {
							if ( ! siblingMenuItems.some( ( sibling ) => sibling.matches( ':hover' ) ) ) {
								firstMenuItem.classList.add( 'is-hover' );
							}
						} );
					} );
				} );
			}
		}
	};

	/**
	 * Mobile menu toggle.
	 *
	 * @return {void}
	 */
	function mobileMenuToggle() {
		const menuBtn = document.querySelector( '.mobile-menu-toggle' );

		if ( null !== menuBtn ) {
			document.addEventListener( 'click', ( event ) => {
				if ( event.target.closest( '.mobile-menu-toggle' ) ) {
					event.preventDefault();

					document.documentElement.classList.toggle( 'mobile-menu-active' );
					document.body.classList.toggle( 'mobile-menu-active' );
					menuBtn.classList.toggle( 'active' );

					setTimeout( () => {
						if ( ! menuBtn.classList.contains( 'active' ) ) {
							document.querySelectorAll( '.primary-menu .sub-menu' ).forEach( ( subMenu ) => {
								subMenu.classList.remove( 'active' );
								subMenu.classList.remove( 'oh-active' );
								document.querySelector( '.primary-menu' ).classList.remove( 'oh-active' );
							} );
						}
					}, 100 );
				}
			} );
		}
	}

	function cloneMenuToChild() {
		const menuWrap = document.getElementById( 'primary-nav' );

		if ( null === menuWrap ) {
			return false;
		}

		const allMenuWithChild = menuWrap.querySelectorAll( '.menu-item-has-children' );

		if ( null === allMenuWithChild ) {
			return false;
		}

		allMenuWithChild.forEach( ( menu ) => {
			const anchorText = menu.querySelector( 'a' ).textContent;
			const liEl = document.createElement( 'li' );
			const anchor = document.createElement( 'a' );

			liEl.classList.add( 'has-back-link' );
			anchor.classList.add( 'back' );
			anchor.setAttribute( 'href', '#' );
			anchor.textContent = anchorText;

			liEl.appendChild( anchor );

			if ( null === menu.querySelector( '.has-back-link' ) ) {
				menu.querySelector( '.sub-menu' ).prepend( liEl );
			}

			document.addEventListener( 'click', ( event ) => {

				if ( event.target.classList.contains( 'back' ) ) {
					event.preventDefault();
					event.target.closest( '.sub-menu' ).classList.remove( 'active' );

					if ( null !== event.target.closest( '.oh-active' ) ) {
						event.target.closest( '.oh-active' ).classList.remove( 'oh-active' );
					}
				}
			} );
		} );
	}

	function openChildMenu() {
		const menuWrap = document.getElementById( 'primary-nav' );

		if ( null === menuWrap ) {
			return false;
		}

		const allMenuWithChild = menuWrap.querySelectorAll( '.menu-item-has-children' );

		if ( null === allMenuWithChild ) {
			return false;
		}

		const debouncedClickHandler = ( event ) => debounce( handleSubMenuClick( event ), 300 );
		document.removeEventListener( 'click', debouncedClickHandler );
		document.addEventListener( 'click', ( event ) => debouncedClickHandler( event ) );
	}

	function handleSubMenuClick( event ) {
		if ( window.outerWidth >= 1025 ) {
			return false;
		}

		if ( event.target.matches( '.menu-item-has-children > a' ) ) {
			event.preventDefault();
			event.target.parentNode.parentNode.scrollTo( 0, 0 );
			event.target.nextElementSibling.classList.toggle( 'active' );
			event.target.parentNode.parentNode.classList.add( 'oh-active' );
			document.querySelector( '.primary-menu' ).classList.add( 'oh-active' );
		}
	}

	function debounce( func, delay ) {
		let timer;
		return function() {
			const context = this;
			const args = arguments;
			clearTimeout( timer );
			timer = setTimeout( () => {
				func.apply( context, args );
			}, delay );
		};
	}

	/**
	 * Call above functions.
	 */
	megaMenuInitHover();
	mobileMenuToggle();
	openChildMenu();

	if ( window.outerWidth <= 1024 ) {
		cloneMenuToChild();
	}

	window.addEventListener( 'resize', function() {
		if ( window.outerWidth <= 1024 ) {
			cloneMenuToChild();
		}

		// Remove back link on desktop view.
		if ( window.outerWidth >= 1025 ) {
			document.querySelectorAll( '.has-back-link' ).forEach( function( backLink ) {
				backLink.remove();
			} );

			document.querySelectorAll( '.oh-active' ).forEach( function( link ) {
				link.classList.remove( 'oh-active' );
			} );

			document.documentElement.classList.remove( 'mobile-menu-active' );
			document.body.classList.remove( 'mobile-menu-active' );
			document.querySelector( '.mobile-menu-toggle' ).classList.remove( 'active' );
			document.querySelectorAll( '.primary-menu .sub-menu' ).forEach( ( subMenu ) => {
				subMenu.classList.remove( 'active' );
				subMenu.classList.remove( 'oh-active' );
				document.querySelector( '.primary-menu' ).classList.remove( 'oh-active' );
			} );
		}
	} );
};
